/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Handover_TitleInputs */

const en_how_we_work_handover_title = /** @type {(inputs: How_We_Work_Handover_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready for everyday use`)
};

const lv_how_we_work_handover_title = /** @type {(inputs: How_We_Work_Handover_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatavs ikdienas darbam`)
};

/**
* | output |
* | --- |
* | "Ready for everyday use" |
*
* @param {How_We_Work_Handover_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_handover_title = /** @type {((inputs?: How_We_Work_Handover_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Handover_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_handover_title(inputs)
	return en_how_we_work_handover_title(inputs)
});